module.exports = __webpack_public_path__ + "img/my.263aea34.svg";